import { QueovalDate } from "..";

export class MissionEC {
  public Ident: string;
  public Name: string;
  public TypeMission: string;
  public IsChecked: boolean;
  public IdRelation: string;
  public MontantMensuel: number;
  public MontantAnnuel: number;
  public CommentFact: string;
  public Remarque: string;
  public Millesime: string;
  public DateDebutExercice: QueovalDate;
  public DateFinExercice: QueovalDate;
  public IsCloture: boolean;
  public MontantFacture: number;
  public MontantNonFacture: number;
  public CodeBOMission: string;
  public CodeRelMission: string;
  public CodeRelMillesime: string;
  public IdPereMission: string
  public Devise: string;
  public TempsTotal: string;
  public MonBoniMali: number;
  public MontantFraisChancellerieFacture: number;
  public MontantFraisChancellerieNonFacture: number;
}
